/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Field_ForcedInputs */



/**
* | output |
* | --- |
* | "Forced" |
*
* @param {Transcript_Export_Field_ForcedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_field_forced = /** @type {((inputs?: Transcript_Export_Field_ForcedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Field_ForcedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Forced")
	if (locale === "de") return /** @type {LocalizedString} */ ("Forced")
	if (locale === "it") return /** @type {LocalizedString} */ ("Forced")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Forced")
	if (locale === "es") return /** @type {LocalizedString} */ ("Forced")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Forced")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Forced")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Forced")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Forced")
	return /** @type {LocalizedString} */ ("Forced")
});